import { css } from 'linaria';

export const delivOpt = css`
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--space-150);
  padding: var(--space-100) 0;

  @media (--from-desktop) {
    padding: var(--space-50) 0;
  }
`;

export const delivOptTextContent = css`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const delivOptIconCntr = css`
  width: var(--space-300);
  height: var(--space-300);
`;
